import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Motion, spring } from 'react-motion'
import styles from './circleFill.styl'

export default class EffectCircleFill extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    isActive: PropTypes.bool.isRequired,
    ratio: PropTypes.number,
    backgroundColor: PropTypes.string
  }
  static defaultProps = {
    ratio: 2.2,
    backgroundColor: '#bd0fe1'
  }

  constructor(props) {
    super(props)
    this.defaultState = {
      x: 0,
      y: 0,
      scaleX: 0,
      scaleY: 0,
      width: 1,
      height: 1,
      opacity: 0
    }
    this.state = this.defaultState
  }

  componentDidMount() {
    this.handleActiveState(null, null, this.props.isActive)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isActive !== nextProps.isActive) {
      if (!nextProps.isActive) {
        this.setState(this.defaultState)
      } else {
        this.handleActiveState(null, null, nextProps.isActive)
      }
    }
  }

  handleClick = e => {
    const rect = this.refs.area.getBoundingClientRect()
    const x = e.pageX - rect.left
    const y = e.pageY - rect.top

    this.handleActiveState(x, y, true)
  }

  handleActiveState = (x = 0, y = 0, active) => {
    const { ratio } = this.props
    const rect = this.refs.area.getBoundingClientRect()
    const largerSide = rect.width > rect.height ? rect.width : rect.height

    if (!active) {
      return
    }

    this.setState({
      x,
      y,
      scaleX: largerSide * ratio,
      scaleY: largerSide * ratio,
      opacity: 1
    })
  }

  handleReset = () => ({
    x: 0,
    y: 0,
    scaleX: 0,
    scaleY: 0,
    width: 1,
    height: 1,
    opacity: 0
  })

  render() {
    const { x, y, scaleX, scaleY, width, height, opacity } = this.state
    const { backgroundColor } = this.props

    return (
      <div ref="area" className={styles.area} onClick={this.handleClick}>
        <Motion
          defaultStyle={{ scaleX: 0, scaleY: 0, opacity: 0 }}
          style={{
            scaleX: spring(scaleX, { stiffness: 100, damping: 20 }),
            scaleY: spring(scaleY, { stiffness: 100, damping: 20 }),
            opacity: spring(opacity, { stiffness: 100, damping: 20 })
          }}
        >
          {iStyle => (
            <div>
              <span
                className={styles.elem}
                style={{
                  left: x,
                  top: y,
                  width,
                  height,
                  opacity,
                  backgroundColor,
                  transform: `scaleX(${iStyle.scaleX}) scaleY(${iStyle.scaleY})`
                }}
              >
                {iStyle.x}
              </span>
              <div className={styles.content}>
                {this.props.children}
              </div>
            </div>
          )}
        </Motion>
      </div>
    )
  }
}
